import SharePointResourceList from './components/SharePointResourceList'
import SharePointDragger from './components/SharePointDragger'
import { SharePointUploaderProps } from './types'
import SharePointUploaderProvider from './SharePointUploaderContext'

const SharePointUploader: React.VFC<SharePointUploaderProps> = ({
  sharePointResourceList,
  folder,
  parent,
  ...rest
}) => {
  return (
    <SharePointUploaderProvider folder={folder} parent={parent}>
      <SharePointDragger {...rest} />
      {sharePointResourceList !== false && (
        <SharePointResourceList {...sharePointResourceList} />
      )}
    </SharePointUploaderProvider>
  )
}

export default SharePointUploader
